export enum ElementCoordinate {
    UpperLeft = "UPPER_LEFT",
    UpperCenter = "UPPER_CENTER",
    UpperRight = "UPPER_RIGHT",
    CenterLeft = "CENTER_LEFT",
    Center = "CENTER",
    CenterRight = "CENTER_RIGHT",
    LowerLeft = "LOWER_LEFT",
    LowerCenter = "LOWER_CENTER",
    LowerRight = "LOWER_RIGHT",
    MobileAbove = "MOBILE_ABOVE",
    MobileBelow = "MOBILE_BELOW"
}